import { render, staticRenderFns } from "./ItemData.vue?vue&type=template&id=7ed41590&"
import script from "./ItemData.vue?vue&type=script&lang=js&"
export * from "./ItemData.vue?vue&type=script&lang=js&"
import style0 from "./ItemData.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports